import { isBrowser } from './src/shared/isBrowser';
import wrapPage from './src/shared/wrapPage';
import wrapRoot from './src/shared/wrapRoot';
export const wrapPageElement = wrapPage;
export const wrapRootElement = wrapRoot;

export const shouldUpdateScroll = () => false;
export const onRouteUpdate = () => {
    if (isBrowser) {
        window.scrollTo({ top: 0 });
    }
};
